import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { object as vObject, string as vString } from 'valibot';

import { TOAST_TIMEOUT } from '@/libs/serenity-ui';
import { userQueries } from '@/resources/user/user.api';
import { tryCatch } from '@/utils/try-catch.util';

export const Route = createFileRoute('/_auth/confirm-email')({
  component: RouteComponent,
  validateSearch: vObject({
    token: vString(),
  }),
  loaderDeps: ({ search }) => ({ token: search.token }),
  beforeLoad: () => {
    if (localStorage.getItem('access_token')) {
      throw redirect({ to: '/' });
    }
  },
  loader: async ({ context, deps }) => {
    const { error } = await tryCatch(context.queryClient.ensureQueryData(userQueries.confirmEmail(deps)));
    if (error) {
      context.toastQueue.add({ message: 'Something went wrong.', variant: 'error' }, { timeout: TOAST_TIMEOUT });
      return;
    }
    context.toastQueue.add({ message: 'Your account is now active, you can sign in!', variant: 'success' }, { timeout: TOAST_TIMEOUT });
  },
});

function RouteComponent() {
  return <Navigate to="/sign-in" />;
}
